import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { SEO } from '@/components/SEO';
import { Mail } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SEO 
        pageType="custom"
        title="Contact | GoCompareAI"
        description="Get in touch with GoCompareAI for general enquiries, feedback, or vendor-related questions."
      />
      <Header />
      
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
          <h1 className="text-3xl sm:text-4xl font-bold text-foreground mb-8">
            Contact GoCompareAI
          </h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-muted-foreground leading-relaxed text-lg mb-8">
              If you have questions, feedback, or would like to get in touch, you can contact us at:
            </p>
            
            <Card className="mb-8">
              <CardContent className="p-6">
                <a 
                  href="mailto:info@gocompareai.com" 
                  className="inline-flex items-center gap-3 text-xl text-primary hover:underline"
                >
                  <Mail className="w-6 h-6" />
                  info@gocompareai.com
                </a>
              </CardContent>
            </Card>
            
            <p className="text-muted-foreground leading-relaxed mb-6">
              We aim to respond to all enquiries as quickly as possible.
            </p>
            
            <p className="text-muted-foreground leading-relaxed">
              For vendors interested in managing or adding platforms, please use the appropriate vendor or platform request options within the site.
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
